import { CameraRoll } from "@components/camera-roll";
import { Heading } from "@radix-ui/themes";
import { Page, usePageTitle } from "@views/layout/layout";
import { SideBarContainer } from "@views/layout/sidebar";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";
import { CameraForm } from "./form";
import { CameraFormProvider } from "./camera-form-context";

export const Camera = () => {
  const [implicitQuery, setImplicitQuery] = useState<[string, string][]>([]);
  const [projectId, setProjectId] = useState<string | undefined>(undefined);
  const { t } = useTranslation();
  usePageTitle("Photographe.ai - Camera");

  return (
    <Page verticalCenter={false}>
      <div className="w-full md:flex">
        <div className="">
          <SideBarContainer>
            <CameraFormProvider
              onChange={({ model, project }) => {
                const query: [string, string][] = [];
                if (model !== "none") query.push(["model", model]);
                setImplicitQuery(query);
                setProjectId(project === "none" ? undefined : project);
              }}
              onRun={() => {}}
            >
              <CameraForm />
            </CameraFormProvider>
          </SideBarContainer>
        </div>

        <div className="grow space-y-8">
          <div className="px-4">
            <div className="relative md:grow md:min-h-0 w-full">
              <div className="-top-16 absolute" id="anchor-camera-roll" />
              <AnimatePresence mode="wait">
                <motion.div className="h-full">
                  <Heading size="4">
                    {t("camera.recent_similar_pictures")}
                  </Heading>
                  <CameraRoll
                    headingPadding="px-2 md:px-1"
                    implicitQuery={implicitQuery}
                    projectId={projectId}
                    className={twMerge("px-0")}
                  />
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
